// extracted by mini-css-extract-plugin
module.exports = {"text":"ErrorModal_text__2gkpn"};